import FormField from "../form-field";
import Select from "../select";
import Api from "../../../../lib/api";

export default class CourseField extends FormField {
	constructor(props) {
		super(props);

		this.select = null;
		this.cityId = null;
		this.initialValue = null;
		this.entryId = null;

		this.ucanMode = craft.page.handle === 'ucan'; //TODO rewrite according to fieldOptions system

		this.GET_ENTRYID_BEFORE_SUBMIT_EVENT = 'getEntryIdBeforeSubmit';
		this.GET_ENTRYID_ON_VALUE_CHANGE_EVENT = 'getEntryIdOnValueChange';

		this.init();
	}

	init() {
		if (!this.$root) {
			throw new Error('CourseField: Root element is not defined!');
		}

		this.select = new Select({
			$root: this.$root.querySelector('.listbox')
		});

		this.cityId = craft.env.cityId || Api.currentCityId;

		if (this.cityId != null) {
			this.fetchCourseList();
		}

		super.init();
	}

	setCityId(cityId) {
		this.cityId = cityId;
	}

	fetchCourseList() {
		if (this.cityId == null) return;

		const coursesFetchUrl = craft.page.handle === 'feedback' ?
			`${ craft.env.apiSiteUrl }/feed/courses-feedback?cityId=${this.cityId}`
			: `${ craft.env.apiSiteUrl }/feed/coursesDropdown?cityId=${this.cityId}`;

		const params = { cityId: this.cityId };

		if (this.ucanMode) {
			Object.assign(params, { ucan: '1', withGroups: '0' });
		}

		this.select.disableButton();
		return Api.get(coursesFetchUrl, {
			cityId: this.cityId
		}).then((data) => {
			this.select.importOptions(data);
			this.select.enableButton();
			if (craft.page.handle == 'courses-entry' && craft.page.courseDirectoryId) {
				this.select.selectOptionByValue(craft.page.courseDirectoryId);
			}
		})
			.catch((err) => {
				throw new Error('Select: Fetch course list failed. ' + err);
			});
	}

	addEventListeners() {
		this.select.subscribe('valueChange', this.handleValueChange.bind(this));
	}

	handleValueChange(e) {
		this.setValue(e.detail);
		this.validateSoft();

		const entryId = this.getEntryId();
		if (entryId) {
			this.dispatchEvent(this.GET_ENTRYID_ON_VALUE_CHANGE_EVENT, entryId);
		}
	}

	validate() {
		this.isValid = this.value !== null;
	}

	getEntryId() {
		const $selectedOption = this.$root.querySelector('[aria-selected]');
		if ($selectedOption == null || !$selectedOption.dataset || !$selectedOption.dataset.entryId) {
			return false;
		}
		return $selectedOption.dataset.entryId;
	}

	setInitialValue(value) {
		this.select.selectOptionByValue(value);
	}

	setInitialState() {
		this.select.setInitialState();

		if (craft.env.cityId == null) {
			this.cityId = null;
		}

		if (this.cityId == null) {
			this.select.disableButton();
		}
	}

	getData() {
		const $selectedOption = this.$root.querySelector('[aria-selected]');
		this.dispatchEvent(this.GET_ENTRYID_BEFORE_SUBMIT_EVENT, $selectedOption.dataset.entryId);
		return super.getData();
	}

	changeCity(cityId) {
		this.setInitialState();
		this.setCityId(cityId);
		return this.fetchCourseList();
	}
}